/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2EyeFilledIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2EyeFilledIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2EyeFilledIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2EyeFilledIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 10"
 style={{'--as-1-Z1r2HEF': alignSelf,'--mt-2-Z1r2HEF': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1r2HEF': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1r2HEF': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1r2HEF': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1r2HEF': opacity,'--w-10-Z1r2HEF': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1r2HEF': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1r2HEF': fill,'--a-7-Z1r2HEF': isAnimated ? animation : "none",'--sd-8-Z1r2HEF': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1r2HEF': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2EyeFilledIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2.514 1.842C3.476 1.114 4.676.5 6 .5c1.324 0 2.524.614 3.486 1.342.966.73 1.731 1.605 2.194 2.193l.004.005c.207.27.316.613.316.96s-.109.69-.316.96l-.003.005c-.464.588-1.228 1.462-2.195 2.193C8.524 8.886 7.324 9.5 6 9.5c-1.324 0-2.524-.614-3.486-1.342C1.548 7.428.783 6.553.32 5.965L.316 5.96A1.585 1.585 0 010 5c0-.347.109-.69.316-.96l.004-.005c.463-.588 1.228-1.462 2.194-2.193zM6 7.025c1.065 0 1.929-.907 1.929-2.025 0-1.118-.864-2.025-1.929-2.025S4.071 3.882 4.071 5c0 1.118.864 2.025 1.929 2.025z"
 style={{'--f-12-Z1r2HEF': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}